
// Since the api runs on the same port as the frontend, the ff should suffice. If things change however,
// the implementation would change...we will use host of the frontend to determine which api url to use.
const getBaseUrl = () => {
  const url = new URL(window.location);
  return url.origin;
};

module.exports = {
    TOKEN_KEY: 'token',
    USER_KEY: 'user',
    // When the user last visited /upcoming (ISO timestamp) - events
    // created after this are "new" and drive the badge on the
    // Upcoming tab. See contexts/UpcomingEventsContext.
    LAST_SEEN_UPCOMING_AT_KEY: 'lastSeenUpcomingAt',
    // Same idea as LAST_SEEN_UPCOMING_AT_KEY, for pending song
    // proposals - drives the badge on the Proposals tab. See
    // hooks/useSongProposals.
    LAST_SEEN_PROPOSALS_AT_KEY: 'lastSeenProposalsAt',
    // Set only when the user picks "Don't ask again" on
    // NotificationPermissionPrompt (routes/EventDetail) - a soft "Not
    // now" leaves this unset, so the prompt can still resurface next
    // time they publish an event.
    NOTIFICATION_PROMPT_DISMISSED_KEY: 'notificationPromptDismissed',
    // Set the first time a non-leader is shown NotificationPermissionPrompt
    // after opening a published event (see EventDetailPage's
    // viewerPromptEligible) - deliberately separate from the "Don't ask
    // again" flag above: a regular member views events far more often
    // than a leader publishes one, so this fires once ever regardless
    // of what they do with the prompt, rather than every single time
    // they open an event.
    EVENT_VIEW_NOTIFICATION_PROMPT_SHOWN_KEY: 'eventViewNotificationPromptShown',
    // Set once the "paste a link to autofill" tip on the propose-song
    // page (SongEditPage) is dismissed - permanent, unlike the
    // notification prompt's "Not now"/"Don't ask again" split, since
    // there's no equivalent "ask again later" value here: once someone's
    // seen it, repeating it on every visit would just be noise.
    AUTOFILL_TIP_DISMISSED_KEY: 'autofillTipDismissed',
    API_BASE_URL: getBaseUrl(),
    // Shared between the Calendar grid and the Upcoming list - same
    // team must render the same color in both places. Index maps to
    // (team.id - 1), so team 1 is TEAM_COLORS[0], etc.
    TEAM_COLORS: [
        { light: "#FA8BB2", main: "#F50057", dark: "#5A0020" },
        { light: "#AED2F0", main: "#4D9DE0", dark: "#1C3A52" },
        { light: "#90E8BB", main: "#0CCE6B", dark: "#054B27" },
        { light: "#D5D1D7", main: "#A39BA8", dark: "#3C393E" },
        { light: "#EDFBCD", main: "#D8F793", dark: "#4F5A36" },
    ],
}
